import { render, staticRenderFns } from "./ModalRemoveGroup.vue?vue&type=template&id=5a2fac92&scoped=true"
import script from "./ModalRemoveGroup.vue?vue&type=script&lang=js"
export * from "./ModalRemoveGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2fac92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a2fac92')) {
      api.createRecord('5a2fac92', component.options)
    } else {
      api.reload('5a2fac92', component.options)
    }
    module.hot.accept("./ModalRemoveGroup.vue?vue&type=template&id=5a2fac92&scoped=true", function () {
      api.rerender('5a2fac92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalRemoveGroup.vue"
export default component.exports